import { useEffect } from "react";
import { DRAWER_MODE, useBottomSheetStore } from "./useBottomSheetStore";
import { useUrlParams } from "@infrastructure/Hooks/useUrlParams";
import { useCommentInputModalOpenCallback } from "../../../Components/Comment/useCommentInputModalOpenCallback";
import { isRunningInNativeIOS } from "@infrastructure/Helpers/IsRunningInNativeApp";

export enum CommentDrawerTriggerMode {
    DEFAULT = "",
    OPEN_DRAWER = "openCommentDrawer",
    OPEN_DRAWER_INPUT_FOCUSED = "openCommentDrawerInputFocused",
}

export function useCommentDrawerTrigger() {
    const { setState, ready } = useBottomSheetStore();
    const { getParam } = useUrlParams();
    const { openCommentInputModal } = useCommentInputModalOpenCallback();

    useEffect(() => {
        const action = getParam("action");
        const isIos = isRunningInNativeIOS();

        if (!ready) {
            return;
        }

        switch (action) {
            case CommentDrawerTriggerMode.OPEN_DRAWER:
                setState(DRAWER_MODE.MAXIMIZED);
                break;
            case CommentDrawerTriggerMode.OPEN_DRAWER_INPUT_FOCUSED:
                setState(DRAWER_MODE.MAXIMIZED);
                if (!isIos) {
                    openCommentInputModal();
                }
                break;
        }
    }, [ready, setState]);
}
